module.exports = __webpack_public_path__ + "static/media/dsr_bg4.9a29f91e.png";